import React, { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

const Message: React.FC<Props> = ({
    children
}) => {
    return (
        <h4>{children}</h4>
    )
}

export default Message;